import ProviderOnboarding from './provider-onboarding';

export default ProviderOnboarding;
